import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getOrders } from "../dispatcher/portalDispatcher";

interface PortalState {
  loading: boolean;
  searching: boolean;
  orders: any[];

  loadingAction: boolean;
  loadingModalAction: boolean;
  order: any;

  totalCount: any;
  totalPages: any;
  pageSize: number;
  page: number;
  sort: any;
  status: string;
  searchQuery: string;
  categoryFilter: string;
  subOrganizationFilter: string;
  sortBy: string;
  requestType: string;
}

const initialState: PortalState = {
  orders: [],
  loading: false,
  searching: false,
  loadingAction: false,

  loadingModalAction: false,

  order: null,

  totalCount: null,
  totalPages: null,
  pageSize: 20,
  page: 1,
  sort: {
    key: "createdAt",
    direction: "desc",
  },
  status: "all",

  // Add new state for search and filters
  searchQuery: "",
  categoryFilter: "all",
  subOrganizationFilter: "all",
  sortBy: "created-desc",
  requestType: "all",
};

// Create a slice for actions and reducers
export const portalSlice = createSlice({
  name: "portal",
  initialState,
  reducers: {
    setOrderSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      state.page = 1; // reset page when searching
      state.searching = true;
    },
    setOrderCategoryFilter: (state, action) => {
      state.categoryFilter = action.payload;
      state.page = 1;
    },
    setSubOrganizationFilter: (state, action) => {
      state.subOrganizationFilter = action.payload;
      state.page = 1;
    },
    setOrderSortBy: (state, action) => {
      state.sortBy = action.payload;
      state.page = 1;
    },
    setOrderPage: (state, action) => {
      state.page = action.payload;
    },
    setRequestType: (state, action) => {
      state.requestType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.pending, (state) => {
        if (!state.searching) {
          state.loading = true;
        }
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.data.orders;
        state.totalCount = action.payload.data.pagination.total;
        state.totalPages = action.payload.data.pagination.totalPages;
        state.pageSize = action.payload.data.pagination.pageSize;
        state.page = action.payload.data.pagination.page;
        state.searching = false;
      })
      .addCase(getOrders.rejected, (state) => {
        state.loading = false;
        state.searching = false;
      });
  },
});

// Export actions
export const {
  setOrderCategoryFilter,
  setOrderPage,
  setOrderSearchQuery,
  setOrderSortBy,
  setRequestType,
  setSubOrganizationFilter,
} = portalSlice.actions;

// Export reducer
export default portalSlice.reducer;
